export default __webpack_public_path__ + "static/national-metric-mobile-c5ff43f7b12df9ab5edee83eeb8d137b.svg";